<script setup>
    defineProps({fill: String});
</script>
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.24308 6.12506L10.8889 7.58795V13.5625C10.8889 13.8052 10.7158 14 10.5001 14H8.9445C8.72879 14 8.55561 13.8052 8.55561 13.5625V10.5H4.66672V13.5625C4.66672 13.8052 4.49354 14 4.27783 14H2.72228C2.50656 14 2.33339 13.8052 2.33339 13.5625V7.71442C1.43104 7.35211 0.777832 6.38825 0.777832 5.25006C0.777832 4.76813 1.12722 4.37506 1.55561 4.37506C1.984 4.37506 2.33339 4.76813 2.33339 5.25006C2.33339 5.732 2.68278 6.12506 3.11117 6.12506H7.24308ZM13.2223 3.06259V3.93759C13.2223 4.90485 12.5265 5.68756 11.6667 5.68756H10.8889V6.66168L7.77783 5.41071V1.31259C7.77783 0.922944 8.1971 0.72812 8.44016 1.00497L9.10552 1.75009H10.4089C10.6732 1.75009 10.9862 1.96542 11.1047 2.23544L11.2778 2.62509H12.8334C13.0491 2.62509 13.2223 2.81992 13.2223 3.06259ZM10.5001 3.06259C10.5001 2.81992 10.3269 2.62509 10.1112 2.62509C9.89545 2.62509 9.72228 2.81992 9.72228 3.06259C9.72228 3.30527 9.89545 3.50009 10.1112 3.50009C10.3269 3.50009 10.5001 3.30527 10.5001 3.06259Z"
      :fill="fill ? fill : '#98A2B3'"
    />
  </svg>
</template>
